import { Injectable, Optional } from "@angular/core";
import { Routes } from "@angular/router";
import { SemLoaderComponent } from "../components/sem-loader/sem-loader.component";

@Injectable({
  providedIn: 'root'
})
export class DynamicLoadingUtil {

  routesLoaded: boolean;
  static loadedDynamicRoutes: any[] = [];
  static loader: SemLoaderComponent;
  static breadcrumbs: any = [];
  static currentRoute: any = {};
  static navigationNodes: any = [];

  constructor() {
  }
  
}
